/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Email_Otp_Purpose_OtherInputs */

const th_email_otp_purpose_other = /** @type {(inputs: Email_Otp_Purpose_OtherInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ดำเนินการต่อ`)
};

const en_email_otp_purpose_other = /** @type {(inputs: Email_Otp_Purpose_OtherInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`continue`)
};

const ja_email_otp_purpose_other = /** @type {(inputs: Email_Otp_Purpose_OtherInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`続ける`)
};

const zh_email_otp_purpose_other = /** @type {(inputs: Email_Otp_Purpose_OtherInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`继续`)
};

const es_email_otp_purpose_other = /** @type {(inputs: Email_Otp_Purpose_OtherInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`continuar`)
};

const pt_email_otp_purpose_other = /** @type {(inputs: Email_Otp_Purpose_OtherInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`continuar`)
};

const id_email_otp_purpose_other = /** @type {(inputs: Email_Otp_Purpose_OtherInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`melanjutkan`)
};

const fr_email_otp_purpose_other = /** @type {(inputs: Email_Otp_Purpose_OtherInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`continuer`)
};

const tl_email_otp_purpose_other = /** @type {(inputs: Email_Otp_Purpose_OtherInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`magpatuloy`)
};

const vi_email_otp_purpose_other = /** @type {(inputs: Email_Otp_Purpose_OtherInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`tiếp tục`)
};

const ko_email_otp_purpose_other = /** @type {(inputs: Email_Otp_Purpose_OtherInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`계속할`)
};

const de_email_otp_purpose_other = /** @type {(inputs: Email_Otp_Purpose_OtherInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`fortfahren`)
};

const ru_email_otp_purpose_other = /** @type {(inputs: Email_Otp_Purpose_OtherInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`продолжить`)
};

const tr_email_otp_purpose_other = /** @type {(inputs: Email_Otp_Purpose_OtherInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`devam etmek`)
};

const it_email_otp_purpose_other = /** @type {(inputs: Email_Otp_Purpose_OtherInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`continuare`)
};

const pl_email_otp_purpose_other = /** @type {(inputs: Email_Otp_Purpose_OtherInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`kontynuować`)
};

const uk_email_otp_purpose_other = /** @type {(inputs: Email_Otp_Purpose_OtherInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`продовжити`)
};

const hi_email_otp_purpose_other = /** @type {(inputs: Email_Otp_Purpose_OtherInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`आगे बढ़ने`)
};

const ar_email_otp_purpose_other = /** @type {(inputs: Email_Otp_Purpose_OtherInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`تتابع`)
};

const ms_email_otp_purpose_other = /** @type {(inputs: Email_Otp_Purpose_OtherInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`meneruskan`)
};

const bn_email_otp_purpose_other = /** @type {(inputs: Email_Otp_Purpose_OtherInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`এগিয়ে যাওয়ার`)
};

const zh_tw2_email_otp_purpose_other = /** @type {(inputs: Email_Otp_Purpose_OtherInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`繼續`)
};

const zh_hk2_email_otp_purpose_other = /** @type {(inputs: Email_Otp_Purpose_OtherInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`繼續`)
};

const ur_email_otp_purpose_other = /** @type {(inputs: Email_Otp_Purpose_OtherInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`آگے بڑھنے`)
};

const fa_email_otp_purpose_other = /** @type {(inputs: Email_Otp_Purpose_OtherInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ادامه دادن`)
};

const sw_email_otp_purpose_other = /** @type {(inputs: Email_Otp_Purpose_OtherInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`kuendelea`)
};

const nl_email_otp_purpose_other = /** @type {(inputs: Email_Otp_Purpose_OtherInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`verder te gaan`)
};

/**
* | output |
* | --- |
* | "continue" |
*
* @param {Email_Otp_Purpose_OtherInputs} inputs
* @param {{ locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }} options
* @returns {LocalizedString}
*/
export const email_otp_purpose_other = /** @type {((inputs?: Email_Otp_Purpose_OtherInputs, options?: { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Email_Otp_Purpose_OtherInputs, { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_email_otp_purpose_other(inputs)
	if (locale === "ja") return ja_email_otp_purpose_other(inputs)
	if (locale === "zh") return zh_email_otp_purpose_other(inputs)
	if (locale === "es") return es_email_otp_purpose_other(inputs)
	if (locale === "pt") return pt_email_otp_purpose_other(inputs)
	if (locale === "id") return id_email_otp_purpose_other(inputs)
	if (locale === "fr") return fr_email_otp_purpose_other(inputs)
	if (locale === "tl") return tl_email_otp_purpose_other(inputs)
	if (locale === "vi") return vi_email_otp_purpose_other(inputs)
	if (locale === "ko") return ko_email_otp_purpose_other(inputs)
	if (locale === "de") return de_email_otp_purpose_other(inputs)
	if (locale === "ru") return ru_email_otp_purpose_other(inputs)
	if (locale === "tr") return tr_email_otp_purpose_other(inputs)
	if (locale === "it") return it_email_otp_purpose_other(inputs)
	if (locale === "pl") return pl_email_otp_purpose_other(inputs)
	if (locale === "uk") return uk_email_otp_purpose_other(inputs)
	if (locale === "hi") return hi_email_otp_purpose_other(inputs)
	if (locale === "ar") return ar_email_otp_purpose_other(inputs)
	if (locale === "ms") return ms_email_otp_purpose_other(inputs)
	if (locale === "bn") return bn_email_otp_purpose_other(inputs)
	if (locale === "zh-TW") return zh_tw2_email_otp_purpose_other(inputs)
	if (locale === "zh-HK") return zh_hk2_email_otp_purpose_other(inputs)
	if (locale === "ur") return ur_email_otp_purpose_other(inputs)
	if (locale === "fa") return fa_email_otp_purpose_other(inputs)
	if (locale === "sw") return sw_email_otp_purpose_other(inputs)
	if (locale === "nl") return nl_email_otp_purpose_other(inputs)
	return en_email_otp_purpose_other(inputs)
});